import { createFormForCollection, getFormComponents } from '../../collectionForm/formComponent';
import { dynamicSort } from '../../../../../common/utils/api_utils';
import { processSteps } from '../../collectionForm/utils';

export default function (editor, opts = {}) {
  const { pfx, projectId, collections, version } = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('sign-up-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Signup Form',
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          isDrop: false,
          traits: [
            {
              type: 'webconnect-event',
              label: false,
              name: 'onsubmit',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
        },
        async init() {
          if (!this.get('isDrop')) {
            this.createComponentItems(projectId);
            this.set('isDrop', true);
          }
          const attrs = this.getAttributes();
          const validationUuid = attrs['data-form-validation'];
          let selectedCollection = null;
          if (collections) {
            selectedCollection = collections.find(
              (collection) => collection.collectionName === 'user',
            );
          }

          let validationOpts = [{ name: '- Select One -', value: '' }];
          if (selectedCollection) {
            const validations = selectedCollection.validations;
            console.log('validations :>> ', validations);
            if (validations && validations.length > 0) {
              validations.sort(dynamicSort('customValidationName')).forEach((validation, key) => {
                validationOpts.push({
                  value: validation.uuid,
                  name: validation.customValidationName,
                });
              });
            }
          }
          const validationTrait = {
            type: 'select',
            // label: 'Validation',
            label: false,
            name: 'validationUuid',
            changeProp: 1,
            options: validationOpts,
            value: validationUuid || '',
          };
          this.addTrait(validationTrait, { at: this.getTraitIndex('onsubmit') + 1 });
          this.on('change:validationUuid', this.handleValidationChange);
        },

        async createComponentItems(projectId) {
          const collection = await getFormComponents('user', collections);
          collection.fields = collection.fields.filter((field) => {
            return (
              field.fieldName !== 'userRoles' &&
              field.fieldName !== 'is_enabled' &&
              field.fieldName !== 'is_email_verified'
            );
          });
          const formElements = await createFormForCollection(
            collection,
            projectId,
            version,
            collections,
          );
          let form = `
            <div class="col-12 col-md-12">
              <h4 class="title">Signup Form</h4>
            </div>
            <div class="form-container row mx-auto" draggable="false" data-gjs-copyable="false" data-gjs-selectable="true" data-gjs-custom-name="Form Container">
                <div class="alert alert-danger alert-message" style="display: none"></div>
                <div class="alert alert-success success-message" style="display: none"></div>
                  ${formElements}
                  <div class="form-group no-border-bottom col-12 col-md-12">
                    <button type="submit" class="btn btn-primary">Signup/Register</button>
                    <a href="/login" class="btn btn-primary ms-2 ml-2 text-bg-primary">Login</a>
                  </div>
            </div>
                            `;
          this ? this.components(form) : '';
        },
        async handleValidationChange() {
          const collectionName = 'user';
          const validationUuid = this.get('validationUuid');
          const cmsProgressBarContainer = document.querySelector(
            '.settings-workflow-event--progress-bar',
          );
          const cmsProgressStep = document.querySelector(
            '.settings-workflow-event-validation--progress',
          );

          if (validationUuid && validationUuid !== 'null' && validationUuid !== '---') {
            const collection = await getFormComponents(collectionName, collections);
            if (collection) {
              const validations = collection.validations;
              if (validations) {
                let selectedValidation = validations.find(
                  (validation) => validation.uuid === validationUuid,
                );
                if (selectedValidation) {
                  this.addAttributes({
                    'data-form-validation': validationUuid,
                  });
                }
              }
            }
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
          } else {
            const attrs = this.getAttributes();
            delete attrs['data-form-validation'];
            this.setAttributes(attrs);

            processSteps(cmsProgressStep, false, cmsProgressBarContainer);
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          }
        },
      },

      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'sign-up-form') {
            return {
              type: 'sign-up-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        // this.listenTo(model,this.updateScript);
      },
    }),
  });
}
